import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, MenuItem, FormControl, InputLabel, Select, Box, Typography, InputAdornment, Tooltip, Divider, Link } from '@mui/material';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import TextField from '../../components/TextField';
import { useTheme } from '@mui/material/styles';
import { useStudent } from './hooks';
import { ArrowBendUpLeft, Check, Info, SealCheck, TrendUp } from '@phosphor-icons/react';
import { getAllWithoutPage } from '../../store/course/courseBaseApi';
import { approveStudent, onboardStudent } from '../../store/student/studentBaseApi';
import { getCourseAssignments } from '../../store/study/studyBaseApi';
import { updateProfile } from '../../store/profile/profileBaseAPi';
import Loader from '../../components/Loader';


export const Edit = () => {
    const { loadCurrent, current, loading } = useStudent();
    const theme = useTheme();
    const { id } = useParams();
    const navigate = useNavigate();
    const [studentDetails, setStudentDetails] = useState();
    const [courseList, setCourseList] = useState([]);
    const [updateDetails, setUpdateDetails] = useState();
    const [courseDetails, setCourseDetails] = useState();
    const [courseId, setCourseId] = useState()

    useEffect(() => {
        if (id) {
            loadCurrent({ id });
        }
    }, [id]);

    useEffect(() => {
        setStudentDetails(current)
    }, [current]);

    useEffect(() => {
        fetchCourses();
    }, [])
    const fetchCourses = async () => {
        let studentCourseDetails = await getCourseAssignments({ userId: id })
        setCourseDetails(studentCourseDetails)
        setCourseId(studentCourseDetails?.data?.courses[studentCourseDetails?.data?.courses.length - 1]?.courseId)
        // let courses = await getAllWithoutPage()
        // console.log("courses",courses.data.data);
        // setCourseList(courses?.data?.data)
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setUpdateDetails({
            ...updateDetails, [name]: value
        })
    }

    const submitOnboard = async () => {
        let sendData = {
            "application": "Intelliread",
            "assignedUserId": id,
            "courseId": updateDetails?.courseId
        }
        let onboard = await onboardStudent(sendData)
    }

    const submitApprove = async () => {
        let sendData = {
            "application": "Intelliread",
            "assignedUserId": id,
            "courseId": courseId
        }

        let onboard = await approveStudent(sendData)
        await updateProfile({
            body: { irStatus: 'ONBOARD' },
            role: 'students', //   Hardcoding the role as of now
            id: id
        });
        toast.success('Student Approve successfully')
        fetchCourses()
        loadCurrent({ id });
    }

    return (
        <>
            {loading ? <Loader /> :
                <Box
                    sx={{
                        padding: '0px 20px',
                        [theme.breakpoints.down('md')]: {
                            padding: '0px',
                        },
                    }}>
                    <div className='question header-container'>
                        <div className='header'>
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
                                <Typography
                                    align="left"
                                    variant="h1"
                                    color="primary.blue"
                                    sx={{
                                        margin: '0',
                                        fontWeight: '700',
                                        lineHeight: '1.5',
                                        fontSize: '2rem',
                                    }}>Student Details</Typography>

                                {/* <Link href={`/student/activity/${id}`} > */}
                                <Button
                                    size='large'
                                    variant="contained"
                                    color="primary"
                                    placeholder={'Activity'}
                                    onClick={() => navigate(`/student/activity/${id}`)}
                                    // disabled={!studentDetails?.irStatus}
                                    startIcon={<TrendUp />}
                                />
                                {/* </Link> */}
                            </Box>
                        </div>


                        <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    align="left"
                                    variant="h6"
                                    color="primary.blue"
                                    x sx={{
                                        margin: '0',
                                        fontWeight: '700',
                                        lineHeight: '1.5',
                                    }}>Personal Details</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>First Name</InputLabel>
                                <TextField
                                    name="firstName"
                                    fullWidth
                                    value={studentDetails?.firstName || ''}
                                    placeholder="Enter First Name"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Last Name</InputLabel>
                                <TextField
                                    name="lastName"
                                    fullWidth
                                    value={studentDetails?.lastName || ''}
                                    placeholder="Enter Last Name"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Date of Birth</InputLabel>
                                <TextField
                                    name="dob"
                                    fullWidth
                                    value={studentDetails?.dob || ''}
                                    inputProps={{
                                        readOnly: true,
                                        value: studentDetails?.dob,
                                    }}
                                    type="date"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Gender</InputLabel>
                                <TextField
                                    name="gender"
                                    fullWidth
                                    value={studentDetails?.gender || ''}
                                    placeholder="Enter Gender"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                        </Grid>
                        <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">

                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    align="left"
                                    variant="h6"
                                    color="primary.blue"
                                    x sx={{
                                        margin: '0',
                                        fontWeight: '700',
                                        lineHeight: '1.5',
                                    }}>Contact Details</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Email</InputLabel>
                                <TextField
                                    name="email"
                                    fullWidth
                                    value={studentDetails?.email || ''}
                                    placeholder=""
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Mobile</InputLabel>
                                <TextField
                                    name="mobile"
                                    fullWidth
                                    value={studentDetails?.mobile || ''}
                                    placeholder=""
                                    type="text"
                                    disabled
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                +91
                                            </InputAdornment>
                                        ),
                                    }}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Address</InputLabel>
                                <TextField
                                    name="address"
                                    fullWidth
                                    value={studentDetails?.address || ''}
                                    // onChange={(e) => handleMarksChange(e)}
                                    placeholder=""
                                    type="text"
                                    disabled
                                />
                            </Grid>
                        </Grid>
                        <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">

                            <Grid item xs={12} sx={{ mt: 2 }}>
                                <Typography
                                    align="left"
                                    variant="h6"
                                    color="primary.blue"
                                    x sx={{
                                        margin: '0',
                                        fontWeight: '700',
                                        lineHeight: '1.5',
                                    }}>Education Details</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>First Language</InputLabel>
                                <TextField
                                    name="firstLanguage"
                                    fullWidth
                                    value={studentDetails?.firstLanguage || ''}
                                    placeholder="Enter First Language"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Grade</InputLabel>
                                <TextField
                                    name="grade"
                                    fullWidth
                                    value={studentDetails?.grade || ''}
                                    placeholder="Enter Grade"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Section</InputLabel>
                                <TextField
                                    name="section"
                                    fullWidth
                                    value={studentDetails?.section || ''}
                                    placeholder="Enter Section"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Admission Date</InputLabel>
                                <TextField
                                    name="admissionDate"
                                    fullWidth
                                    value={studentDetails?.admissionDate || ''}
                                    inputProps={{
                                        readOnly: true,
                                        value: studentDetails?.dob,
                                    }}
                                    type="date"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>School Name</InputLabel>
                                <TextField
                                    name="schoolName"
                                    fullWidth
                                    value={studentDetails?.schoolName || ''}
                                    placeholder="Enter School Name"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Learning Generation</InputLabel>
                                <TextField
                                    name="learningGeneration"
                                    fullWidth
                                    value={studentDetails?.learningGeneration || ''}
                                    placeholder="Enter Learning Generation"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Geographical Type</InputLabel>
                                <TextField
                                    name="geographicalType"
                                    fullWidth
                                    value={studentDetails?.geographicalType || ''}
                                    // onChange={(e) => handleMarksChange(e)}
                                    placeholder="Enter Geographical Type"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3} >
                                <InputLabel style={styles.inputLabel}>Grade Level</InputLabel>
                                <TextField
                                    name="gradeLevel"
                                    fullWidth
                                    value={studentDetails?.gradeLevel || ''}
                                    placeholder="Enter Grade Level"
                                    type="text"
                                    disabled
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 4, display: 'flex', gap: '10px' }}>
                            <Button
                                size='large'
                                variant="contained"
                                onClick={() => navigate('/student')}
                                color="primary"
                                placeholder={'Back'}
                                startIcon={<ArrowBendUpLeft />}
                            />
                            {courseDetails?.data.courses[courseDetails?.data?.courses.length - 1].currentStatus !== "IN_PROGRESS" &&
                                <Button
                                    size='large'
                                    variant="contained"
                                    // disabled={!(updateDetails?.courseId)} 
                                    onClick={submitApprove}
                                    color="primary"
                                    placeholder={'Approve Student'}
                                    startIcon={<SealCheck />}
                                />
                            }
                        </Box>


                    </div>
                </Box >
            }
        </>
    )
}


const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        mt: 2,
        mb: 3
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};